import { render, staticRenderFns } from "./TutorAddConfirm.vue?vue&type=template&id=68dd4d98"
import script from "./TutorAddConfirm.vue?vue&type=script&lang=ts"
export * from "./TutorAddConfirm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports